import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { RAWMATERIAL_SALES_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const RawMaterialSalesApi = createApi({
  reducerPath: "RawMaterialSales",
  baseQuery,
  tagTypes: ["RawMaterialSales"],
  endpoints: (builder) => ({
    getRawMaterialSales: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: RAWMATERIAL_SALES_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: RAWMATERIAL_SALES_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["RawMaterialSales"],
    }),
    getRawMaterialSalesById: builder.query({
      query: ({ id }) => {
        return {
          url: `${RAWMATERIAL_SALES_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["RawMaterialSales"],
    }),
    addRawMaterialSales: builder.mutation({
      query: (payload) => ({
        url: RAWMATERIAL_SALES_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["RawMaterialSales"],
    }),
    updateRawMaterialSales: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${RAWMATERIAL_SALES_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["RawMaterialSales"],
    }),
    deleteRawMaterialSales: builder.mutation({
      query: (id) => ({
        url: `${RAWMATERIAL_SALES_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RawMaterialSales"],
    }),
  }),
});

export const {
  useGetRawMaterialSalesQuery,
  useGetRawMaterialSalesByIdQuery,
  useAddRawMaterialSalesMutation,
  useUpdateRawMaterialSalesMutation,
  useDeleteRawMaterialSalesMutation,
} = RawMaterialSalesApi;

export default RawMaterialSalesApi;
